import React , {useState} from 'react';

import { Navigation, Scrollbar, A11y   } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import icon1 from '../../assets/images/icon/rain1.svg'
import icon2 from '../../assets/images/icon/rain2.svg'
import icon3 from '../../assets/images/icon/ethe.svg'

function LiveAutions3(props) {
    const { data } = props;
    const { addToCart } = useCart();
    const [addedItems, setAddedItems] = useState({});

    const handleAddToCart = (item) => {
        addToCart({
            id: item.id,
            title: item.title,
            price: '₹1000',
            img: item.img
        });
        setAddedItems(prev => ({ ...prev, [item.id]: true }));
        setTimeout(() => {
            setAddedItems(prev => ({ ...prev, [item.id]: false }));
        }, 2000);
    };

    return (
        <section className="tf-section tf-live-auction">
            <div className="tf-container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="tf-heading style-2 mb30 wow fadeInUp">
                            <h4 className="heading">Hot Vouchers</h4>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <Swiper
                            modules={[Navigation,  Scrollbar, A11y ]}
                            spaceBetween={15}
                            breakpoints={{
                                0: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                    },
                                500: {
                                    slidesPerView: 2,
                                    spaceBetween: 15,
                                    },
                                767: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                991: {
                                    slidesPerView: 3,
                                    spaceBetween: 20,
                                },
                                1300: {
                                    slidesPerView: 4,
                                    spaceBetween: 20,
                                },
                            }}
                            className="live-auction pt10 wow fadeInUp"
                            // navigation
                            loop= {true}
                        >
                        {
                            data.map(idx => (
                                <SwiperSlide key={idx.id}>
                                    <div className="slider-item">
                                            <div className="sc-product style1">
                                                <div className="top">
                                                    <Link to="/item-details-v1" className="tag">{idx.title}</Link>
                                                    <div className="wish-list">
                                                        <Link to="#" className="heart-icon"></Link>
                                                    </div>
                                                </div>
                                                <div className="features">
                                                    <div className="product-media">
                                                        <img src={idx.img} alt="images" />
                                                    </div>
                                                    <div className="featured-countdown">
                                                        <span className="js-countdown" data-timer="55555" data-labels=" ,  h , m , s "></span>
                                                    </div>
                                                    <div className="rain-drop1"><img src={icon1} alt="images" /></div>
                                                    <div className="rain-drop2"><img src={icon2} alt="images" /></div>
                                                </div>
                                                <div className="bottom">
                                                    <div className="details-product">
                                                        <div className="author">
                                                            <div className="content">
                                                                <div className="position">E-Gift Card</div>
                                                                <div className="name"> <Link to="#">Instant E-Voucher</Link></div>
                                                            </div>
                                                        </div>
                                                        <div className="current-bid">
                                                            <div className="subtitle">Price</div>
                                                            <div className="price">
                                                                <span className="cash">₹1000</span><span className="icon"><img src={icon3} alt="images" /></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="product-button">
                                                        <button 
                                                            onClick={(e) => { e.preventDefault(); handleAddToCart(idx); }} 
                                                            className="tf-button" 
                                                            style={{
                                                                border: 'none', 
                                                                cursor: 'pointer',
                                                                transition: 'all 0.4s ease-in-out',
                                                                transform: addedItems[idx.id] ? 'scale(1.05)' : 'scale(1)',
                                                                backgroundColor: addedItems[idx.id] ? '#FFC107' : '',
                                                                color: addedItems[idx.id] ? '#000' : ''
                                                            }}
                                                        >
                                                            <span className="icon-btn-product" style={{
                                                                transition: 'transform 0.3s ease',
                                                                display: 'inline-block',
                                                                transform: addedItems[idx.id] ? 'rotate(360deg)' : 'rotate(0deg)'
                                                            }}></span> {addedItems[idx.id] ? 'Added to Cart!' : 'Buy Now'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                </SwiperSlide>
                                
                            ))
                        }
                        </Swiper>

                    </div>
                    <div className="col-md-12">
                        <div className="btn-loadmore mt8">
                            <Link to="/explore" className="tf-button loadmore style-5">See more</Link>
                        </div>
                    </div>
                </div>
            </div>

        </section> 
    );
}

export default LiveAutions3;